import React from 'react';
import useBuildContentstackImageSrc from '@drc/hooks/useBuildContentstackImageSrc';
import { Image } from '@stockx/ui';

const UserGeneratedContentModalImage = ({ imageUrl = '' }) => {
  const { imageSrc, imageSrcSet } = useBuildContentstackImageSrc({
    src: imageUrl,
    options: {
      width: 638,
      height: 638,
    },
  });

  return (
    <Image
      referrerPolicy="origin"
      borderRadius="sm"
      srcSet={imageSrcSet}
      src={imageSrc}
    />
  );
};

export default UserGeneratedContentModalImage;
